import api from "../../services/api";

const BASE_URL = "/api/v1/auth/users";

export const rbacService = {
  // Get all users with their roles
  getAllUsers: async () => {
    try {
      const response = await api.get(BASE_URL);
      return response.data || [];
    } catch (error) {
      console.error("RBAC service error:", error);
      throw error;
    }
  },

  // Get user by ID
  getUserById: async (id) => {
    const response = await api.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  // Update user role
  updateUserRole: async (id, roleData) => {
    const response = await api.put(`${BASE_URL}/${id}`, roleData);
    return response.data;
  },

  // Create new user
  createUser: async (userData) => {
    const response = await api.post(BASE_URL, userData);
    return response.data;
  },

  // Delete user
  deleteUser: async (id) => {
    const response = await api.delete(`${BASE_URL}/${id}`);
    return response.data;
  },

  // Get role permissions/definitions
  getRoleDefinitions: () => {
    return {
      SuperAdmin: {
        name: "Super Admin",
        description: "Full access to everything in the system",
        permissions: ["All permissions"],
        color: "red",
      },
      Admin: {
        name: "Admin",
        description: "Global admin with most system access",
        permissions: ["User management", "System configuration", "Reports"],
        color: "orange",
      },
      HRHead: {
        name: "HR Head",
        description: "Can create/manage employees, leave policy, etc.",
        permissions: ["Employee management", "Leave policy", "Recruitment"],
        color: "purple",
      },
      HRExecutive: {
        name: "HR Executive",
        description: "Can view and manage leave requests, onboarding tasks",
        permissions: ["Leave requests", "Onboarding", "Employee data"],
        color: "blue",
      },
      Manager: {
        name: "Manager",
        description: "Team manager — views team leaves, approves tickets",
        permissions: ["Team management", "Leave approval", "Team reports"],
        color: "green",
      },
      TeamLead: {
        name: "Team Lead",
        description: "Light manager — views assigned employee tickets",
        permissions: ["Team oversight", "Ticket assignment", "Basic reports"],
        color: "teal",
      },
      Employee: {
        name: "Employee",
        description: "Default role — limited access",
        permissions: ["Personal data", "Basic ticketing", "Leave requests"],
        color: "gray",
      },
      Finance: {
        name: "Finance",
        description: "Access to payroll, reimbursements",
        permissions: [
          "Payroll management",
          "Reimbursements",
          "Financial reports",
        ],
        color: "yellow",
      },
      ITAdmin: {
        name: "IT Admin",
        description: "Full access to all tickets (assigned/unassigned)",
        permissions: ["All tickets", "IT infrastructure", "System maintenance"],
        color: "cyan",
      },
      ITSupport: {
        name: "IT Support",
        description: "Can view/update only assigned tickets",
        permissions: [
          "Assigned tickets",
          "Technical support",
          "User assistance",
        ],
        color: "blue",
      },
      Auditor: {
        name: "Auditor",
        description: "Read-only view of HR/ticket data",
        permissions: [
          "Read-only access",
          "Audit reports",
          "Compliance monitoring",
        ],
        color: "pink",
      },
    };
  },
};
